import { Location } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { animationExpandCollapse } from 'src/app/core/animations/expand-collapse.animations';
import { StringHelper } from 'src/app/core/helpers/string.helper';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'expandable-list-item',
  templateUrl: './expandable-list-item.component.html',
  animations: [animationExpandCollapse],
  standalone: false
})
export class ExpandableListItemComponent implements OnInit {
  @Input() opened = false;
  @Input() title: string;
  @Output() toggleItem: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private element: ElementRef
  ) {}

  ngOnInit(): void {
    // Check if the title equals the hash fragment. If so, start opened.
    const safeTitle = StringHelper.toKebabCase(this.title);
    const hash = this.route.snapshot.fragment;
    if (hash && safeTitle === hash.toLowerCase()) {
      this.opened = true;
      // Automatically scroll element in view
      setTimeout(() => {
        (this.element.nativeElement as HTMLElement).scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 50);
    }
  }

  onItemClick(): void {
    this.toggleItem.emit();

    const url = this.router
      .createUrlTree(['./'], { relativeTo: this.route.parent, fragment: `${StringHelper.toKebabCase(this.title)}` })
      .toString();
    this.location.go(url);
  }
}
